exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".info-text.widget {\n  margin: 6px;\n  color: #AAAAAA;\n  font-size: 11px;\n  word-wrap: break-word;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/widget/info-text/index.css
// module id = 506
// module chunks = 0